export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14914.1ff1cc01.jpg";